import { Checkbox, Flex, Select } from "@theorgchartdev/storybook";
import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX, BuildAzureCloudEnvironmentOptions } from "../Utils";
import { appstr } from "@coreapp/utils/appstr";

export const AzureADSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  var useAzureAdvQuery = config.advQuery == true;
  const cloudEnvironment = config.cloudEnvironment || "commercial";

  const handleCloudEnvironmentSelect = option => {
    onChange({ ...config, cloudEnvironment: option.value });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    >
      <Flex direction={"column"}>
        <Select
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-azuread-cloud-env-select`}
          selectSize={"medium"}
          inputOnly={false}
          label={appstr("Microsoft account type")}
          value={cloudEnvironment}
          options={BuildAzureCloudEnvironmentOptions(handleCloudEnvironmentSelect)}
        />
        <Checkbox
          id={"entra-adv-query"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-azuread-adv-query-checkbox`}
          label={appstr("Use advanced Entra Query")}
          size={"medium"}
          checked={useAzureAdvQuery}
          onChange={() => {
            onChange({ ...config, advQuery: !useAzureAdvQuery });
          }}
        />
      </Flex>
    </DataSourceSetupComposite>
  );
};
